import { createTextObject } from './textHelpers';
import { parseInlineFormatting } from './inlineFormattingHelpers';

const FONT_SIZE = 7;
const LIST_ITEM_REGEX = /^(\d+)\.\s+(.*)/;
const BULLET_ITEM_REGEX = /^-\s+(.*)/;

export function isListItem(line: string): boolean {
    return line.trim().startsWith('- ');
}

export function isNumberedItem(line: string): boolean {
    return /^\d+\. /.test(line);
}

export function parseListItem(line: string): any[] {
  const elements: any[] = [];
  const listItemMatch = line.match(LIST_ITEM_REGEX);
  const bulletItemMatch = line.match(BULLET_ITEM_REGEX);

  switch (true) {
    case Boolean(listItemMatch): {
      const [_, number, remainingText] = listItemMatch!;
      const fullText = `${number}. ${remainingText}`;
      elements.push(...parseInlineFormatting(fullText));
      break;
    }
    case Boolean(bulletItemMatch): {
      const [_, remainingTextBullet] = bulletItemMatch!;
      const fullText = `• ${remainingTextBullet}`;
      elements.push(...parseInlineFormatting(fullText));
      break;
    }
    default: {
      elements.push(createTextObject(line, FONT_SIZE));
      break;
    }
  }

  return elements;
}

